"use client";

// FeedbackForm.tsx
import { useState } from "react";
import { MessageCircleMore } from "lucide-react";
import { useSelector } from "react-redux";

export default function FeedbackForm({
  show,
  handleClose,
}: {
  show: boolean;
  handleClose: () => void;
}) {
  const [feedbackBtn, setFeedbackBtn] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const {userData} = useSelector((state)=>state.main)

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (feedbackBtn) return;
    try {
      setFeedbackBtn(true);
      let formdata = {
        email: form.email,
        message: form.message,
        name: form.name,
        userId: userData._id
      }
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/help-desk`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formdata),
        }
      );
      const data = await res.json();
      // console.log(data, "-----------data")
      if (res.ok) {
        alert("Thanks for your message! We'll get back to you shortly.");
        handleClose();
        setForm({ name: "", email: "", message: "" });
      } else {
        alert("Failed to submit: " + data.message);
      }
    } catch (err: any) {
      alert("Error submitting form: " + err.message);
    } finally {
      setFeedbackBtn(false);
    }
  };

  if (!show) return null; // Only render when asked to

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border dark:border-white/10 border-black/10 dark:bg-neutral-900 bg-accent shadow-2xl ring-1 ring-black/5">
        <div className="flex items-center justify-between gap-3 p-2 border-b dark:border-white/10 border-black/10">
          <div className="flex items-center gap-3">
            <div className="grid place-content-center size-12 rounded-xl bg-white/[0.03] ring-1 dark:ring-white/10 ring-black/10">
              <MessageCircleMore className="size-7 dark:text-neutral-400 text-black" />
            </div>
            <h2 className="text-xl font-semibold">Share Feedback?</h2>
          </div>
          <button
            onClick={handleClose}
            className="rounded-lg p-2 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-5">
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Your name"
              required
              value={form.name}
              onChange={handleChange}
              className="w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
            />
            <input
              type="email"
              name="email"
              placeholder="Your email"
              required
              value={form.email}
              onChange={handleChange}
              className="w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
            />
            <textarea
              name="message"
              rows={4}
              placeholder="Type your message here..."
              required
              value={form.message}
              onChange={handleChange}
              className="w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30 resize-none"
            ></textarea>

            <div className="flex flex-col items-center space-y-3 mt-4">
              <button
                type="submit"
                className="w-full rounded-xl dark:bg-white bg-black dark:text-neutral-900 text-white font-medium py-3 hover:bg-white hover:text-black transition-colors"
                disabled={feedbackBtn}
              >
                {feedbackBtn ? "Please wait..." : "Send"}
              </button>
              <button
                type="button"
                className="dark:text-white text-neutral-900 hover:underline"
                onClick={handleClose}
              >
                No thanks
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
